module.exports = __webpack_public_path__ + "img/bg-footer.1d93a802.png";